import Blue from "~/core";

new Blue({
	name: 'Form Validate',
	selector: ".formValidate",
	setup(form) {
		this.$validate(form);
	}
});


new Blue({
	name: 'Currency Input Formatting',
	selector: "input.form-control--currency",
	setup(input) {
		function deFormatCurrency(string) {
			let arr = string.split("");
			let num = ["0","1","2","3","4","5","6","7","8","9"];
			return arr.filter(n => num.includes(n)).join("");
		}
		function formatCurrency(input) {
			let val = deFormatCurrency(input.value);
			let arr = val.split("");
			if (arr.length > 3) {
				let div = Math.floor(arr.length / 3);
				if (arr.length % 3 === 0) div--;
				for (div; div > 0; div--) {
					arr.splice(-3 * div, 0, ",");
				}
			}
			input.value = '$' + arr.join("");
		}
		this.$addEvents(input, "keyup", () => {
			formatCurrency(input);
		})
	}
});